import { render, staticRenderFns } from "./UiModal.vue?vue&type=template&id=700081f7&lang=pug&"
import script from "./UiModal.vue?vue&type=script&lang=ts&"
export * from "./UiModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports